// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"6476177f","237":"e599f69a","461":"f157a7bc","551":"4e26a20c","591":"c60ab1f0","683":"3eef4476","732":"6a71efa1","787":"735a7c21","981":"01620d3c"}[chunkId] + ".chunk.js";
};